export default
{
	GOOGLE_MAP_API_KEY_URL: "https://www.google.com/maps/embed/v1/search?key=AIzaSyBZ1CPDXfpOYYH_fHkmbVKx0FWcHiAnaoc&q=",

	SHOW_LOADING: "show",
	HIDE_LOADING: "hide",

	CHAR_YES: "Y",
	CHAR_NO: "N",

	PASSWORD_CHANGE_REQUIRED_FLAG_YES: "Y",
	PASSWORD_CHANGE_REQUIRED_FLAG_NO: "N",

	TICKET_HAS_FEEDBACK: "Y",
	TICKET_HAS_NO_FEEDBACK: "N",

	TAB_WINDOW_WIDTH: 767,//670, //768,
	DESKTOP_WINDOW_WIDTH: 1200,
	MOBILE_LANDSCAPE_WIDTH: 540,
	DESKTOP_WINDOW_HEIGHT: 945,

	// Asset condition recommendation section expand/collapse
	EXPANDED_HEIGHT: '200px',
	COLLAPSED_HEIGHT: '32px',

	//Sensor app id
	APP_ID_SPIN: 0,
	APP_ID_SPARK: 1,

	// App name
	APP_NAME_SPIN: "MyVIE-Spin",
	APP_NAME_SPARK: "MyVIE-Spark",

	ASSET_TYPE_TRANSFORMER: "TRANSFORMER",

	ADMIN_USERNAME: "admin",
	ADMIN_USER_TYPE_ID: 1,
	SUPPORT_USERNAME: "support",
	SUPPORT_USER_TYPE_ID: 3,
	SYSTEM_USERNAME: "system",
	SYSTEM_USER_TYPE_ID: 4,

	// MAIN PAGE
	ASSET_ADDRESS_GOOGLE_MAP_SCREEN: "assetAddressGoogleMap",
	ASSET_CONDITION_INFO_SCREEN: "assetConditionInfo",
	ASSET_DETAILS_SCREEN: "assetDetailsPage",
	SUPER_ASSET_LIST_SCREEN: "superAssetList",
	ASSET_LIST_SCREEN: "assetList",
	ASSET_HISTORY_SCREEN: "assetHistory",
	ASSET_PM_SCHEDULE_SCREEN: "assetPMSchedule",
	DASHBOARD_SCREEN: "dashboard",
	CHANGE_PASSWORD_POPUP: "changePassword",
	ADD_USER_FEED_SCREEN: "addUserFeed",
	FEEDS_SCREEN: "feeds",
	FEED_ASSIGN_SCREEN: "feedAssign",
	FEED_COMMENT_SCREEN: "feedComment",
	METRICS_SCREEN: "metrics",
	USER_DETAILS_SCREEN: "userDetailsPage",
	USERS_SCREEN: "users",
	ASSET_PLOTLY_GRAPH_SCREEN: "assetPlotlyGraph",
	ASSET_PLOTLY_TABLE_SCREEN: "assetPlotlyTable",
	ASSET_INFO_SCREEN: "assetInfo",
	ASSET_TREND_HISTORY_SCREEN: "assetTrendHistory",
	ASSET_QUICK_FEEDBACK_SCREEN: "assetQuickFeedback",
	ADD_OR_REPLACE_SENSOR_SCREEN: "addOrReplaceSensorScreen",
	TICKET_DETAILS_SCREEN: "ticketDetailsPage",
	SENSOR_LIST_SCREEN: "sensorListPage",
	SENSOR_INFO_SCREEN: "sensorInfo",
	SUPER_ASSET_COMMENT_SCREEN: "superAssetComment",
	SENSOR_HISTORY_SCREEN: "sensorHistory",
	USER_PREFERENCES_SCREEN: "userPreferences",
	NOTIFICATION_FEEDBACK_SCREEN: "feedback",
	OIL_TEST_REPORT_UPLOAD_SCREEN: "transformerOilTestReportUpload",

	ASSET_CONDITION_HEADER: "Asset Condition",
	SENSOR_STATE_HEADER: "Sensor State",
	SENSOR_LIST_SCREEN_HEADER: "sensors installed location", //"Sensor List",
	ASSET_CONDITION_INFO_SCREEN_HEADER: "Asset Condition Info",
	ASSET_LIST_SCREEN_HEADER: "Monitored Locations",
	SUPER_ASSET_LIST_SCREEN_HEADER: "Assets",
	ASSET_QUICK_FEEDBACK_SCREEN_HEADER: "Quick Feedback",
	REPLACE_SENSOR_SCREEN_HEADER: "Replace Sensor",
	ADD_SENSOR_SCREEN_HEADER: "Add sensor",
	ASSET_HISTORY_SCREEN_HEADER: "Asset Feed - ",
	ADD_USER_FEED_SCREEN_HEADER: "Add Post",
	FEEDS_SCREEN_HEADER: "Feeds",
	FEED_ASSIGN_SCREEN_HEADER: "Assign to",
	FEED_COMMENT_SCREEN_HEADER: "Feed Comment",
	METRICS_SCREEN_HEADER: "Metrics",
	USERS_SCREEN_HEADER: "Users",
	SENSOR_COMMENT_SCREEN_HEADER: "Sensor Comment",
	SUPER_ASSET_COMMENT_SCREEN_HEADER: "Asset Comment",
	SENSOR_HISTORY_SCREEN_TITLE: "Sensor history",
	USER_PREFERENCES_HEADER: "User Preferences",

	//SSO 

	//Sensor State
	SENSOR_STATE_ALL: "All",
	SENSOR_STATE_ACTIVE_LABEL: "Active",
	SENSOR_STATE_UNRESPONSIVE_LABEL: "Unresponsive",
	SENSOR_STATE_DETACHED_LABEL: "Detached",

	SENSOR_ID_MAX_LENGTH: 8,
	SENSOR_MAC_ADDRESS_MAX_LENGTH: 12,

	SENSOR_UNRESPONSIVE_REASON_UNKNOWN: 0,
	SENSOR_UNRESPONSIVE_REASON_SENSOR_MISSING: 4,
	SENSOR_UNRESPONSIVE_REASON_BATTERY_LEVEL_LOW_OR_DEAD: 2,
	SENSOR_BATTERY_LEVEL_THRESHOLD: 70,

	USER_SESSION_KEY: "user",
	SAML_VALIDATION_DETAILS_SESSION_KEY: "samlValidationDetails",
	USER_SESSION_EXPIRED_STATUS: "userSessionExpiredStatus",
	DYNAMIC_API_BASE_URL_SESSION_STORAGE_KEY: "dynamicApiBaseUrl",
	DYNAMIC_API_BASE_URL_DELIMETER: "-",

	// Restricted menus for SAML
	RESTRICTED_MENU_IDS_SAML: ['changePassword'],

	//Authentication page
	FORGOT_PASSWORD_SCREEN: "forgotpassword",
	LOG_OUT_SCREEN: "logout",
	SIGNIN_SCREEN: "signin",
	LICENSE_AGREEMENT_SCREEN: "licenseAgreementScreen",

	//LOGIN TYPES

	LOGIN_TYPE_MYVIE: "myVIE",
	LOGIN_TYPE_SAML: "saml",
	LOGIN_TYPE_VIE_INTERNAL: "vie-sso",
	LOGIN_TYPE_FEEDBACK: "feedback",
	LOGIN_TYPE_KEY: "loginType",

	// FEED TYPES
	FEED_TYPE_USER: "UE",
	FEED_TYPE_ASSET: "AE",
	FEED_TYPE_USER_TICKET: "UT",
	FEED_TYPE_ASSET_TICKET: "AT",

	EVENT_HAS_TICKET: "YES",

	//TICKET
	TICKET_OPEN: "OPEN",
	TICKET_REOPENED: "REOPENED",
	TICKET_REOPEN: "REOPEN",
	TICKET_CLOSE: "CLOSE",
	TICKET_CLOSED: "CLOSED",
	TICKET_CLOSED_WITHOUT_FEEDBACK: "CLOSED_WITHOUT_FEEDBACK",
	TICKET_STATE_TCR: "TCR",
	TICKET_STATE_TA: "TA",
	TICKET_STATE_TF: "TF",
	TICKET_STATE_TC: "TC",
	TICKET_STATE_CM: "CM",
	TICKET_STATE_TO: "TO",

	TICKET_TCR_COMMENT: " created ticket and assigned to ",
	TICKET_TA_COMMENT: " assigned ticket to ",
	TICKET_TF_COMMENT: " provided feedback",
	TICKET_TC_COMMENT: " closed the ticket",
	TICKET_TO_COMMENT: " reopened the ticket",

	//CUSTOMER
	CUSTOMER_ID_ALL: 0,
	DUMMY_ASSET_ID: 0,

	CUSTOMER_TYPE_TEXT_PRIMARY: "PRIMARY",
	CUSTOMER_TYPE_TEXT_SECONDARY: "SECONDARY",

	CUSTOMER_TYPE_CHAR_PRIMARY:"P",
	CUSTOMER_TYPE_CHAR_SECONDARY:"S",

	CUSTOMER_TYPE_PRIMARY: 1,
	CUSTOMER_TYPE_SECONDARY: 2,
	CUSTOMER_TYPE_ARCHIVED: 7,

	USER_AVAILABLE_STATE: 1,
	USER_UNAVAILABLE_STATE: 0,

	//ASSETS
	ASSET_STATE_REGISTERED: 0,
	ASSET_STATE_MONITORED: 2,
	ASSET_STATE_DATA_RX_TIMEOUT_EXCEEDED: 3,
	ASSET_STATE_OPERATIONAL: 4,
	ASSET_STATE_NOT_OPERATIONAL: 5,
	ASSET_STATE_DECOMMISSIONED: 6,
	ASSET_STATE_ARCHIVED: 7,
	ASSET_STATE_SENSOR_DETACH_SUSPECTED: 8,

	ASSET_STATE_DATA_RX_TIMEOUT_EXCEEDED_TEXT: "Data Rx Timeout Exceeded",

	ASSET_STATE_DECOMMISSIONED_TEXT: "Decommissioned",

	PLOTLY_X_AXIS_CPM: "CPM",
	PLOTLY_X_AXIS_FREQUENCY: "Frequency",

	FEEDBACK_HEALTHY: "HEALTHY",
	FEEDBACK_MINOR_ISSUE_ADDRESSED: "MINOR_ISSUE_ADDRESSED",
	FEEDBACK_MINOR_ISSUE_UNADDRESSED: "MINOR_ISSUE_UNADDRESSED",
	FEEDBACK_MINOR_ISSUE_DIAGNOSED: "MINOR_ISSUE_DIAGNOSED",
	FEEDBACK_MAJOR_ISSUE_ADDRESSED: "MAJOR_ISSUE_ADDRESSED",
	FEEDBACK_MAJOR_ISSUE_UNADDRESSED: "MAJOR_ISSUE_UNADDRESSED",
	FEEDBACK_MAJOR_ISSUE_DIAGNOSED: "MAJOR_ISSUE_DIAGNOSED",

	// Feedback types that carry a user selected issue addressed date. Add any new issue type here as well
	FEEDBACK_TYPES_WITH_ISSUE_CHECKUP_DATE:
	[
		"MINOR_ISSUE_ADDRESSED",
		"MINOR_ISSUE_UNADDRESSED",
		"MAJOR_ISSUE_ADDRESSED",
		"MAJOR_ISSUE_UNADDRESSED"
	],

	GRAPH_TYPE_CURRENT: "C",
	GRAPH_TYPE_HISTORICAL: "H",
	HISTORICAL_DATA_REFRESH_TIMER: 10, // minutes
	GRAPH_PERIOD_TYPES: ["CURRENT DATA", "HISTORICAL DATA"],

	ASSET_DEFAULT_DATE: 1000,

	CALIBRATING_CONDITION_TEXT: "CALIBRATING",
	CHECKUP_CONDITION_TEXT: "Checkup",
	GOOD_CONDITION_TEXT: "Good",
	UNKNOWN_CONDITION_TEXT: "Unknown",
	URGENT_CONDITION_TEXT: "Urgent_Attention",
	TOOLTIP_URGENT_CONDITION: "Urgent",
	TOOLTIP_CHECKUP_CONDITION: "Checkup",
	TOOLTIP_GOOD_CONDITION: "Good",
	TOOLTIP_UNKNOWN_CONDITION: "Unknown",

	HEALTHY: "Good",
	MINOR_ISSUE_ADDRESSED: "Checkup",
	MINOR_ISSUE_UNADDRESSED: "Checkup",
	MINOR_ISSUE_DIAGNOSED: "Checkup",
	MAJOR_ISSUE_ADDRESSED: "Urgent_Attention",
	MAJOR_ISSUE_UNADDRESSED:"Urgent_Attention",
	MAJOR_ISSUE_DIAGNOSED: "Urgent_Attention",

	Urgent_Attention: 1,
	Checkup: 2,
	Good: 3,
	Unknown: 4,

	// Trend priority
	trendPriority: 
	{
		'2' : 1,
		'1' : 2,
		'-1': 3,
		'0' : 4
	},

	UP_ARROW_TREND_NUMERIC: 1,
	DOUBLE_UP_ARROW_TREND_NUMERIC: 2,

	REFRESH_FEEDS_INITIATED: false,

	DEFAULT_DATETIMESTAMP: 0,
	// ASSET_CONDITION_COUNT_REFRESH_TIMER: 30000,
	ASSET_DETAILS_REFRESH_TIMER: 30000,
	ASSET_LIST_REFRESH_TIMER: 30000,
	CUSTOMER_LIST_REFRESH_TIMER: 30000,
	USER_LIST_REFRESH_TIMER: 30000,
	USER_DETAILS_REFRESH_TIMER: 60000,
	FEED_LIST_REFRESH_INTERVAL_TIMER: 30000,
	SENSOR_LIST_REFRESH_TIMER: 300000,
	SENSOR_UNRESPONSIVE_REASON_LIST_TIMER: 60000,

	// Screen context storage
	ADD_SCREEN_CTXT_TO_SESSION:  0,
	PUSH_SCREEN_CTXT_TO_SESSION: 1,
	POP_SCREEN_CTXT_FROM_SESSION: -1,
	
	//toast
	TYPE_ERROR: "error",
	TYPE_INFO: "info",
	TYPE_SUCCESS:"success",

	//Messages
	ENTER_SIGNIN_CREDENTIALS_MESSAGE: "Please specify User Name / Email, password and Account",
	ENTER_FORGOT_PASSWORD_CREDENTIALS_MESSAGE: "Please specify User Name / Email and Account",
	ENTER_USERNAME_OR_EMAIL_MESSAGE: "Please specify User Name / Email",
	ENTER_EMAIL_MESSAGE: "Please specify email address",
	ENTER_ACCOUNT_MESSAGE: "Please specify account",
	ENTER_VALID_EMAIL_MESSAGE: "Please specify valid Email",
	SIGNIN_ERROR_MESSAGE: "Error Occured. Please Try again..!",
	INVALID_SIGNIN_ERROR_MESSAGE: "Invalid Credentials. Please Try again..!",
	SESSION_EXPIRED_MESSAGE: "Session Expired",

	//Change password
	CHANGE_PASSWORD_SUCCESS_MESSAGE: "Password Changed Successfully",
	INVALID_PASSWORD_MESSAGE: "Invalid old Password",
	OLD_PASSWORD_EMPTY_MESSAGE: "Please enter your old password.",
	NEW_PASSWORD_EMPTY_MESSAGE: "Please enter a new password.",
	CONFIRM_NEW_PASSWORD_EMPTY_MESSAGE: "Please confirm your new password.",
	OLD_AND_NEW_PASSWORD_SHOULD_BE_DIFFERENT_MESSAGE: "Old password and new password should be different",
	NEW_AND_CONFIRM_PASSWORD_SHOULD_BE_SAME_MESSAGE : "New password and confirm new password doesn't match",
	NEW_PASSWORD_MIN_LENGTH_MESSAGE: "Password must be at least 8 characters long",
	NEW_PASSWORD_UPPERCASE_MESSAGE: "Password must include at least one uppercase letter",
	NEW_PASSWORD_LOWERCASE_MESSAGE: "Password must include at least one lowercase letter",
	NEW_PASSWORD_NUMBER_MESSAGE: "Password must include at least one number",
	NEW_PASSWORD_SPECIAL_CHARACTER_MESSAGE: "Password must include at least one special character",
	PASSWORD_POLICY_ERROR_MESSAGE: "Password does not meet the required format. Please follow the password requirements.",

	//Asset
	NO_ASSETS_MESSAGE: "No assets defined in the system",
	NO_ASSET_INFO_MESSAGE: "No asset info found",
	NO_SENSOR_INFO_MESSAGE: "No sensor info found",
	NO_ASSETS_FOUND_BY_CUSTOMER_MESSAGE: "No assets found for selected customer",
	NO_ASSETS_FOUND_BY_ASSET_TAG_MESSAGE: "No assets matching the specified criteria - ",
	NO_SENSORS_FOUND_BY_SEARCH_TEXT: "No sensors matching the specified criteria - ",
	NO_ASSETS_FOUND_BY_PROGNOSIS_MESSAGE: "No assets in condition - ",
	NO_ASSET_CONDITION_INFO_MESSAGE: "No asset condition info found",
	NO_ASSET_DETAILS_MESSAGE: "No asset details found",
	IN_COMPLETE_FEEDBACK: "Incomplete feedback !",
	NO_GRAPH_DATA_MESSAGE:  "Data not available",
	NO_GRAPH_DATA_BY_PARAM_MESSAGE: "Data not available for ",
	NO_ANALYSIS_DATA_MESSAGE: "Analysis data not available",
	NO_PLOTLY_GRAPH_DATA_MESSAGE: "No graph data found",
	NO_PLOTLY_TABLE_DATA_MESSAGE: "No table data found",
	NO_OPEN_TICKETS: "No Open Tickets",
	ASSET_GRAPH_PARAM_NO_DESCRIPTION_HEADER: "No Description",
	ASSET_GRAPH_PARAM_NO_DESCRIPTION: "No description found for the ",
	NO_TICKET_DETAILS_MESSAGE: "No ticket details found",
	UPDATE_CUST_ASSET_TAG_ERROR_MESSAGE: "Update failed",
	ENTER_ONLY_NUMBER_MESSAGE: "Only integer values allowed for ",
	EMPTY_CUST_ASSET_TAG_MESSAGE: "Component name must be specified",
	SELECT_ISSUE_ADDRESSED_DATE_MESSAGE: "Please select issue addressed date",
	TREND_NOT_YET_DETERMINED_MESSAGE: "Trend not yet determined",
	NO_SUPER_ASSET_COMMENTS_PROVIDED_MESSAGE: "No comments provided so far..",
	IMAGE_DELETE_SUCCESS: "Image has been successfully deleted.",
	IMAGE_DELETE_ERROR: "Unable to delete the image. Please try again.",
	IMAGE_ROTATE_SUCCESS: "Rotated image has been saved successfully.",
	IMAGE_ROTATE_ERROR: "Unable to rotate the image. Please try again.",
	ALTERNATE_ID_UPDATE_SUCCESS: "Alternate ID updated successfully.",
	ALTERNATE_ID_UPDATE_ERROR: "Unable to update alternate ID. Please try again.",
	EMPTY_ALTERNATE_ID_MESSAGE: "Alternate ID must be specified",
	ALTERNATE_ID_NOT_SPECIFIED_TEXT: "Not specified",


	DEFAULT_VISIBLE_TICKET_COUNT: 5,

	GRAPH_LEGEND_DATE_FORMAT: "MM-dd-YYYY HH:MM:SS",
	GRAPH_X_AXIS_DATE_FORMAT: "MM-dd-YYYY HH:MM",
	DEFAULT_UNIT_PREFERENCE: 0,
	ALTERNATE_UNIT_PREFERENCE: 1,
	UNIT_TYPE_VELOCITY: "Velocity",
	UNIT_TYPE_TEMPERATURE: "TEMPERATURE",
	FREQUENCY_TYPE_SPECTRUM: "Spectrum",
	FREQUENCY_TYPE_MIXED_FREQUENCY: "Mixed Frequency",
	FREQUENCY_TYPE_WAVEFORM: "Waveform",
	UNIT_TYPE_ACCELERATION: "Acceleration",


	MEASUREMENT_DATA_FILE_DATE_FORMAT: 'MMDDYYYY',
	FILE_EXTENSION: '.csv',
	MEASUREMENT_DOWNLOAD_SUCCESS_MESSAGE: "Measurement Data downloaded successfully",
	QUICK_FEEDBACK_TICKET_CREATION_SUCCESS_MESSAGE: "Ticket has been created based on your feedback",
	QUICK_FEEDBACK_TICKET_CREATION_FAILED_MESSAGE: "Ticket creation failed",
	MEASUREMENT_DATA_CALENDER_FORMAT: "YYYY-MM-DD",
	MEASUREMENT_DATA_START_TIME: " 00:00:00",
	MEASUREMENT_DATA_END_TIME: " 23:59:59",
	MEASUREMENT_DATA_DOWNLOAD_TIME_PERIOD: 180,
	MEASUREMENT_DATA_DAYS: "days",
	FILE_DOWNLOAD_TIME_PERIOD_EXCEEDED_ALERT: "Please specify maximum of 180 days interval for data download",
	FILE_DOWNLOAD_FAILED_MESSAGE: "Measurement Data download failed. Please try again later.",
	MEASUREMENT_DATA_LOCATION_LABEL_MISSING_MESSAGE: "Measurement data cannot be downloaded for an asset not having a location label.",
	MOTE_INSTALLED_STATE_UPDATED_SUCCESS_MESSAGE: "Mote Installed state updated",
	MOTE_INSTALLED_STATE_UPDATED_ERROR_MESSAGE: "Mote Installed state not updated. Please try again",
	FEEDBACK_SUCCESS_FROM_PM_SCHEDULE_MESSAGE: "Request to clear the alert has been submitted. Please wait for few minutes for it to take effect.",
	FEEDBACK_ERROR_FROM_PM_SCHEDULE_MESSAGE: "Your request could not be processed now. Please try again after some time",
	FEEDBACK_FROM_PM_SCHEDULE_PROCESSING_MESSAGE: "Processing your request",
	SENSOR_LIST_DOWNLOADING_MESSAGE: "Downloading sensors installed location",
	SENSOR_LIST_DOWNLOAD_SUCCESS_MESSAGE: "Sensors installed location downloaded successfully",
	SENSOR_LIST_DOWNLOAD_FAILED_MESSAGE: "Sensors installed location download failed. Please try again later.",
	UPDATE_SENSOR_UNRESPONSIVE_REASON_FAILED_MESSAGE: "Update of sensor unresponsive reason failed. Please try again later",

	//Ticket
	ASSIGN_USER_ERROR_MESSAGE: "Unable to assign user to ticket. Please try again!",
	FEEDBACK_SUCCESS_MESSAGE: "Feedback added successfully for ",
	FEEDBACK_ERROR_MESSAGE: "Unable to add feedback. Please try again!",
	TICKET_CLOSED_SUCCESS_MESSAGE: " closed successfully",
	TICKET_CLOSED_ERROR_MESSAGE: "Unable to close the ticket. Please try again!",
	TICKET_REOPENED_SUCCESS_MESSAGE: " reopened successfully",
	TICKET_REOPENED_ERROR_MESSAGE: "Unable to reopen the ticket. Please try again!",
	DISPATCH_TICKET_SUCCESS_MESSAGE: "Dispatched Successfully",
	DISPATCH_TICKET_ERROR_MESSAGE: "Could not be Dispatched. Please try again later!",
	TICKET_ASSIGNED_TO_SAME_TECHNICIAN_MESSAGE: "The ticket is already assigned to the selected technician",

	CENTER_DATE_TIME_FORMAT: "MM/DD/YYYY HH:MM:SS",
	PLOTLY1_JSON:"plotly1Json",
	PLOTLY2_JSON:"plotly2Json",
	PLOTLY1_VEL_JSON: "plotly1VelJson",
	PLOTLY2_VEL_JSON: "plotly2VelJson",
	PLOTLY1_ACC_JSON: "plotly1AccJson",
	PLOTLY2_ACC_JSON: "plotly2AccJson",
	TIME_SERIES_PLOTLY_JSON: "timeSeriesPlotlyJson",
	LOG_SCALE_PLOTLY_JSON: "logScalePlotlyJson",

	ASSET_MOTE_STATE_DEPLOYED: "D",
	ASSET_MOTE_STATE_INACTIVE: "A",

	ASSET_MOTE_STATE_DEPLOYED_TEXT: "Deployed",
	ASSET_MOTE_STATE_INACTIVE_TEXT: "Inactive",
	ASSET_MOTE_STATE_NOT_INSTALLED_TEXT: "Not_Installed",

	NOT_AVAILABLE_TEXT: "Not Available",

	// PM schdeule feedback
	PM_SCHEDULE_FEEDBACK: "HEALTHY-Scheduled Maintenance-MAINT ITEM",
	PM_SCHEDULE_FEEDBACK_NOTES: "Auto-cleared",

	//Feeds
	NO_FEEDS: "No feeds",

	// Feed Assign
	ADD_USER_FEED_MESSAGE: "Please specify comments",
	SELECT_ASSET_MESSAGE: "Please select an asset tag",
	SELECT_DUE_DATE_MESSAGE: "Please specify due date",
	SELECT_USER_MESSAGE: "Please select the technician for assigning the ticket",
	ASSIGN_TICKET_BY_USER_OR_ASSET_MESSAGE: "Unable to assign ticket by user / asset Feed. Please try again!",

	//Metric
	NO_METRIC_DATA_MESSAGE: "No metrics data found",

	//User
	NO_USERS_MESSAGE: "No users defined in the system",
	NO_USERS_FOUND_BY_CUSTOMER_MESSAGE: "No users found for selected customer",
	NO_USERS_FOUND_BY_NAME_MESSAGE: "No users matching the specified criteria - ",

	//Sensor
	ENTER_SENSOR_ID_MESSAGE: "Please specify sensor id",
	ENTER_SENSOR_INFO_MOTE_HEIGHT_IN_MESSAGE: "Please specify height",
	ENTER_SENSOR_INFO_AXIAL_AXIS_MESSAGE: "Please specify axial axis",
	ENTER_SENSOR_INFO_VERTICAL_AXIS_MESSAGE: "Please specify vertical axis",
	ENTER_SENSOR_MAC_ADDRESS_MESSAGE: "Please specify sensor MAC address",
	SENSOR_REPLACEMENT_SUCCESS_MESSAGE: "Sensor replaced successfully",
	SENSOR_REPLACEMENT_ERROR_MESSAGE: "Error while replacing sensor. Please try again later!",
	SENSOR_ID_SENSOR_MAC_ADDRESS_MISMATCH: "Sensor MAC address does not correspond to the specified Sensor ID.",
	SENSOR_MAC_ADDRESS_SENSOR_ID_MISMATCH: "Sensor ID does not correspond to the specified Sensor MAC address.",
	NO_SENSOR_HISTORY_FOUND_MESSAGE: "No sensor history found for the asset",
	SENSOR_COMMENT_PLACEHOLDER_EMPTY: "No sensor related notes provided so far...",
	SENSOR_ADD_SUCCESS_MESSAGE: "Sensor has been added successfully.",
	SENSOR_ADD_FAILED_MESSAGE:"Unable to add sensor. Please try again.",


	FILE_DOES_NOT_EXIST: "Unable to fetch / display image. Please contact support.",
	SUPER_ASSET_NO_IMAGES_PROVIDED_MESSAGE: "No images provided for this equipment",
	ASSETS_NO_IMAGES_PROVIDED_MESSAGE: "No images provided for this asset",
	IMAGE_URL_EXPIRED: "Unable to fetch / display image. Please click on reload button.",
	QUICK_FEEDBACK_DROPDOWN_ERROR_MESSAGE: "Please fill in all required fields.",
	SUPER_ASSET_IMAGE_TYPE: "SUPER_ASSET_IMAGE",
	ASSET_IMAGE_TYPE: "ASSET_IMAGE",

	UPDATE_SENSOR_INFO_MESSAGE: "Sensor Info updated successfully",
	UPDATE_SENSOR_INFO_ERROR_MESSAGE: "Error while updating sensor info. Please try again later!",
	SENSOR_ATTRIBUTES_ERROR_MESSAGE: "No changes detected. Please modify at least one sensor attribute.",
	SENSOR_DETACH_SUCCESS_MESSAGE: "Sensor detached successfully.",
	SENSOR_DETACH_ERROR_MESSAGE: "Unable to detach Sensor (SENSOR_ID) right now. Please try agin later!",
	UNATTACHED_SENSOR_ERROR_MESSAGE: "Unable to fetch the unattached sensor.",
	DEFAULT_SENSOR_ID: "00-00-00-00",

	//Color
	PRIMARY_COLOR: "#041f00",
	DANGER_COLOR: "#f44236",
	LIGHT_COLOR: "#ffffff",
	GREY_COLOR: "#d6d6d6",
	LIGHT_PRIMARY_COLOR: "#fafff4",
	DARK_GREY_COLOR: "#5E5E5E",
	AXIS :
		[
			{
				value: "x",
				label: "X"
			},
			{
				value: "y",
				label: "Y"
			},
			{
				value: "z",
				label: "Z"
			}
		],

	//Feedback Files
	DUPLICATED_FEEDBACK_FILES: "Duplicate file detected. Please select a different file to upload.",
	FEEDBACK_FILE_EXPIRED_MESSAGE: "Unable to load file. Please try again later",
	FEEDBACK_FILE_DOWNLOAD_MESSAGE: "Unable to download file. Please try again later",
	FEEDBACK_FILE_PREVIEW_ERROR_MESSAGE: "Preview option not available currently. Please try downloading the file instead.",
	DOWNLOAD_FEEDBACK_FILES_ERROR_MESSAGE: "Unable to download the file. Please try again.",

	URGENT_ATTENTION_RUM_NUMERIC: 2,
	CHECKUP_RUM_NUMERIC: 1,
	GOOD_RUM_NUMERIC: 0,
	UNKNOWN_RUM_NUMERIC: 0,
	DOUBLE_UP_ARROW_RUM_NUMERIC: 2,
	SINGLE_UP_ARROW_RUM_NUMERIC: 1,
	DOWN_ARROW_RUM_NUMERIC: 0,
	HYPHEN_RUM_NUMERIC: 0,

	CONDITION_RUM_DETERMINATION: {
		"Urgent_Attention": 2,
		"Checkup": 1,
		"Good": 0,
		"Unknown": 0
	},
	TREND_RUM_DETERMINATION:
	{
		"2": 2,
		"1": 1,
		"-1": 0,
		"0": 0
	},
	TREND_LIMIT_IN_DAYS: 14,
	FEEDBACK_NOTE_MAX_LENGTH: 4000,
	ASSET_COMMENT_MAX_LENGTH: 4000,
	PERFORMANCE_GRAPH_SCREENSHOT_DOWNLOAD_SUCCESS_MESSAGE: "Performance graph screenshot has been successfully downloaded to your device",
	TIMESERIES_SINGLE_PARAM_GRAPH: 1,
	TIMESERIES_COMPARISON_GRAPH: 2,
	TREND_UP_ARROW_SVG: "icon_trend_up_arrow",
	TREND_DOWN_ARROW_SVG: "icon_trend_down_arrow",
	TREND_DOUBLE_UP_ARROW_SVG: "icon_trend_double_up_arrow",

	// Oil Report Status
	OIL_TEST_REPORT_STATUS_TO_BE_PROCESSED: "To Be Processed",
	OIL_TEST_REPORT_STATUS_PROCESSED: "Processed",
	OIL_TEST_REPORT_STATUS_FAILED: "Failed",

	OIL_TEST_REPORT_FILE_EMPTY_MESSAGE: "Please select a Oil Report file",
	OIL_TEST_REPORT_UPLOAD_SUCCESS_MESSAGE: "Oil Report file uploaded successfully",
	OIL_TEST_REPORT_UPLOAD_ERROR_MESSAGE: "Oil Report file upload failed. Please try again.",
	OIL_TEST_REPORT_NO_FILES_MESSAGE: "No files uploaded yet",
}